export class CustomComponent extends HTMLElement {
  constructor() {
    super();

    if (new.target === CustomComponent) {
      throw new Error('CustomComponent is abstract and must be extended.');
    }

    // if(this.childNodes.length > 0) {
    //   console.warn(`⚠️ Child Node being passed to ${this.constructor.name} is not supported yet. 🚧 We are working on supporting child nodes for custom components.`);
    // }

    if(!this._initialized) {
      this._directChildren = Array.from(this.children).map(d => d.outerHTML).join("");
    }

    this._state = {};
    this._manualProps = {};
    this._childrenHTML = '';
    this._root = null;
    this._initialized = false;
  }

  get props() {
    const attrProps = {};
    for (const attr of this.attributes) {
      const key = attr.name.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
      attrProps[key] = attr.value;
    }
    return { ...attrProps, ...this._manualProps };
  }

  get state() {
    return this._state;
  }

  set state(newState) {
    this._state = { ...this._state, ...newState };
    this._render();
  }

  setState(partialState) {
    this.state = partialState;
  }

  connectedCallback() {
    // Capture and preserve original light DOM children once
    if (!this._initialized) {
      const children = Array.from(this.childNodes).filter(n => n.nodeType !== Node.COMMENT_NODE);
      const wrapper = document.createElement('div');
      children.forEach(child => wrapper.appendChild(child.cloneNode(true)));
      this._childrenHTML = wrapper.innerHTML;
      this._initialized = true;

      this.innerHTML = '';
    }

    this._render();
    this.onLoad?.();
  }

  disconnectedCallback() {
    this.onUnload?.();
  }

  /*
  * Override in subclass to run code when the component is updated
  */
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue && this._initialized) {
      this._render();
    }
  }

  _render() {
    // if (!this._childrenHTML) return;

    const style = this.style?.();
    const _style = style ? `<style>${style}</style>` : '';

    const _html = this.render?.(this._directChildren);
    if (typeof _html !== 'string') {
      throw new Error('render() must return a string');
    }


    this.beforeRender?.();
    this.innerHTML = _style + _html;
    this.afterRender?.();
  }

  /*
  * Override in subclass to return the HTML string to render
  */
  render(_childrenHTML) {
    throw new Error('Subclasses must implement render()');
  }

  /*
  * Override in subclass to run code before rendering
  */
  beforeRender() {
    // Override in subclass to run code before rendering
  }

  /*
  * Override in subclass to run code after rendering
  */
  afterRender() {
    // Override in subclass to run code after rendering
  }

  /*
  * Override in subclass to return the CSS string to render
  */
  style() { return ''; }

  /*
  * Override in subclass to run code when the component is loaded
  */
  onLoad() {}

  /*
  * Override in subclass to run code when the component is unloaded
  */
  onUnload() {}

  // shouldComponentUpdate(oldProps, newProps) {
  //   return JSON.stringify(oldProps) !== JSON.stringify(newProps);
  // }
}

export default CustomComponent;